import React from "react";
import { useFormContext } from "react-hook-form";
import { Controller } from "react-hook-form";
import { FieldWrapper } from "../../../../../../DocumentUploads/Forms/GeneratedDocuments/FormFields/__styles__/FormFields";
import Checkbox from "../../../../../../Inputs/Checkbox";
import { Text } from "../../../../../../Inputs/react-hook-form";
import { SelectedSubmissionsBuilderField } from "../../reducer";
import {
  InputFieldPath,
  SubmissionsBuilderFieldSettings,
  SubmissionsBuilderFormDataStructure,
} from "../../types";
import { WidgetSettingsContainer } from "./__styles__/WidgetSettings";
import {
  DefaultValuesSection,
  DisplaySettingsSection,
  FieldPermissionsConfig,
  FieldSettingConfig,
} from "./shared";

const CheckboxWidgetSettings = ({
  fieldPath,
  isModuleInput,
  readOnly,
}: SelectedSubmissionsBuilderField & SubmissionsBuilderFieldSettings) => {
  const { register, watch } =
    useFormContext<SubmissionsBuilderFormDataStructure>();
  const isFormulaField = !!watch(`${fieldPath}.formula`);

  return (
    <WidgetSettingsContainer>
      <FieldSettingConfig
        fieldPath={fieldPath}
        isModuleInput={isModuleInput}
        isFormulaField={isFormulaField}
        readOnly={readOnly}
        labelRequired={false}
      />
      <div>
        <Text
          {...register(`${fieldPath}.checkboxText`)}
          label="Checkbox text"
          required
          disabled={readOnly}
        />
      </div>
      <DefaultValuesSection>
        <CheckboxDynamicDefaultInput
          fieldPath={fieldPath}
          readOnly={readOnly}
        />
      </DefaultValuesSection>
      <FieldPermissionsConfig fieldPath={fieldPath} />
      <DisplaySettingsSection fieldPath={fieldPath} readOnly={readOnly} />
    </WidgetSettingsContainer>
  );
};

const CheckboxDynamicDefaultInput = ({
  fieldPath,
  readOnly,
}: {
  fieldPath: InputFieldPath;
  readOnly: boolean;
}) => {
  const { control, watch } =
    useFormContext<SubmissionsBuilderFormDataStructure>();

  const defaultValuePath = watch(`${fieldPath}.defaultValuePath`);

  return (
    <FieldWrapper data-testid="dynamic-default-value-wrapper">
      <Controller
        control={control}
        name={`${fieldPath}.defaultValuePath`}
        render={({ field }) => {
          return (
            <Checkbox
              value={defaultValuePath === "boolean.true" ? true : false}
              label={field.value === "boolean.true" ? "Checked" : "Unchecked"}
              disabled={readOnly}
              onChange={(value: boolean) =>
                field.onChange(value ? "boolean.true" : undefined)
              }
            />
          );
        }}
      />
    </FieldWrapper>
  );
};

CheckboxWidgetSettings.displayName = "CheckboxWidgetSettings";

export default CheckboxWidgetSettings;
